/**
 * Auto-generated API Client
 *
 * Generated by @spfn/core codegen
 * DO NOT EDIT MANUALLY
 *
 * @generated 2025-11-03T13:40:07.039Z
 */

export { client } from '@spfn/core/client';

export type { GetLabelsResponse, GetLabelsQuery, CreateLabelResponse, CreateLabelBody, GetLabelResponse, GetLabelParams, UpdateLabelResponse, UpdateLabelParams, UpdateLabelBody, DeleteLabelResponse, DeleteLabelParams } from './cms-labels.js';
export type { GetLabelByKeyResponse, GetLabelByKeyParams } from './cms-labels-by-key.js';
export type { PublishLabelResponse, PublishLabelParams, PublishLabelBody } from './cms-labels-publish.js';
export type { GetAdminLabelResponse, GetAdminLabelParams } from './cms-labels-admin.js';
export type { GetLabelVersionsResponse, GetLabelVersionsParams } from './cms-labels-versions.js';
export type { GetPublishedCacheResponse, GetPublishedCacheQuery, UpsertPublishedCacheResponse, UpsertPublishedCacheBody } from './cms-published-cache.js';
export type { SaveValuesResponse, SaveValuesParams, SaveValuesBody, GetValuesResponse, GetValuesQuery, GetValuesParams } from './cms-values.js';

import { getLabels, createLabel, getLabel, updateLabel, deleteLabel } from './cms-labels.js';
import { getLabelByKey } from './cms-labels-by-key.js';
import { publishLabel } from './cms-labels-publish.js';
import { getAdminLabel } from './cms-labels-admin.js';
import { getLabelVersions } from './cms-labels-versions.js';
import { getPublishedCache, upsertPublishedCache } from './cms-published-cache.js';
import { saveValues, getValues } from './cms-values.js';

/**
 * Type-safe API client
 */
export const cmsApi = {
    getLabels,
    createLabel,
    getLabel,
    updateLabel,
    deleteLabel,
    getLabelByKey,
    publishLabel,
    getAdminLabel,
    getLabelVersions,
    getPublishedCache,
    upsertPublishedCache,
    saveValues,
    getValues
} as const;
